import { PlayBoxOutlineIcon } from './PlayBoxOutlineIcon';

/**
 * author: Google
 * id D0431F42-A1C2-409B-9D44-2EDDEF3F9AB3
 * name play-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play-box-outline.svg
 * tags
 */
export const SlideshowIcon = PlayBoxOutlineIcon;
export default SlideshowIcon